import { Arr } from '../../../CodesForFoundation';
import { Rect } from '../../../platform/geom/Rect';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { FlexLayout } from '../autoLayout/FlexLayout';
import { Voter } from './Voter';
import { VoterTitleFieldTextSettings } from './VoterTitleField';

export const VoterLayout = (object: Voter) => {

    const base = new Rect(0, 0, object.width, object.height);
    const inner = base.inflate([-40, -30]);

    const titleSettings = VoterTitleFieldTextSettings(object);
    const titleWidth = TextRuler.measureSize(object.title, titleSettings).w;
    const titleHeight = TextRuler.measureHeight(object.title, titleSettings, titleWidth);

    const title = inner.set({ width: titleWidth, height: titleHeight });

    const footer = inner.set({ top: inner.bottom - 50, height: 50 });

    const [revealReset] = FlexLayout.layoutRects(
        footer,
        ['row', 'center', 'center', 10],
        [new Rect(0, 0, 140, 50)],
    );

    const itemsInner = inner
        .inflate([10, 0])
        .set({
            top: title.bottom + 20,
            height: (revealReset.top - 20) - (title.bottom + 20),
        });

    const itemWidth = Math.round(itemsInner.width / object.items.length);
    const items = object.items.map((x, i) =>
        itemsInner
            .set({ left: itemsInner.left + (i * itemWidth), width: itemWidth, })
            .inflate([-10, 0])
    );

    const itemLookup = Object.fromEntries(items.map((x, i) => [`item${i}`, x]));

    const votesTop = inner.set({ height: 30 });

    const votesX = object.votes
        .map((v, i) => ({
            userId: v.userId,
            area: new Rect(votesTop.right - 30 - (20 * i), votesTop.top, 30, 30),
        }));

    const votesByItem = Arr.groupBy(object.votes, 'itemId');
    const votesY = Object.entries(votesByItem).map(([tm, vvs]) => {
        const item = items[object.items.findIndex(x => x.id === tm)];
        if (!item) return null;
        const area = new Rect(item.left, item.top, item.width, 0).inflate([-10, 15]);
        const stack = vvs.map((_v, i) => new Rect(i * 20, 0, 30, 30));
        const stackWidth = Rect.fromMany(stack).width;
        return vvs.map((v, i) => ({
            userId: v.userId,
            area: stack[i].offset(area.topLeft().add([(area.width - stackWidth) / 2, 0])),
        }));
    }).flatMap(x => x ?? []);

    const votes = object.state === 'voting' ? votesX : votesY;
    return { base, inner, title, votes, items, ...itemLookup, revealReset };
};

export type VoterLayout = ReturnType<typeof VoterLayout>;
